import { CommonModule } from '@angular/common';
import { Component, Input, NgModule, OnDestroy } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { Subject } from 'rxjs';

interface CurrencyCodeSymbol {
  code: string;
  symbol?: string;
}

@Component({
  selector: 'aux-currency-choice',
  template: `
    <glxy-form-field>
      <glxy-label>{{ 'ADMINISTRATION.CUSTOM_FIELDS.CURRENCY_TYPE' | translate }}</glxy-label>
      <mat-select [formControl]="currencyFormControl" (openedChange)="onBlur($event)">
        <mat-option *ngFor="let currency of AllowedCurrencyCodes" [value]="currency.code">
          {{ currency.code }}
          <span *ngIf="currency.symbol">({{ currency.symbol }})</span>
        </mat-option>
      </mat-select>
    </glxy-form-field>
  `,
  styles: [``],
  standalone: false,
})
export class CurrencyChoiceComponent implements OnDestroy {
  @Input() currencyFormControl: UntypedFormControl;

  // copied from auxiliary-data: https://github.com/vendasta/auxiliary-data/blob/master/pkg/fieldschema/validators.go#L19-L49
  // which copied off of https://pkg.go.dev/golang.org/x/text/currency
  AllowedCurrencyCodes: CurrencyCodeSymbol[] = [
    { code: 'USD', symbol: '$' },
    { code: 'AUD', symbol: 'A$' },
    { code: 'BRL', symbol: 'R$' },
    { code: 'CAD', symbol: 'CA$' },
    { code: 'CHF' }, //https://en.wikipedia.org/wiki/Swiss_franc
    { code: 'CNY', symbol: 'CN¥' },
    { code: 'DKK', symbol: 'kr.' }, //https://en.wikipedia.org/wiki/Danish_krone
    { code: 'EUR', symbol: '€' },
    { code: 'GBP', symbol: '£' },
    { code: 'HKD', symbol: 'HK$' },
    { code: 'HKD', symbol: 'HK$' },
    { code: 'IDR', symbol: 'Rp' },
    { code: 'INR', symbol: '₹' },
    { code: 'KRW', symbol: '₩' },
    { code: 'MXN', symbol: 'MX$' },
    { code: 'NOK', symbol: 'kr' }, //https://en.wikipedia.org/wiki/Norwegian_krone
    { code: 'NZD', symbol: 'NZ$' },
    { code: 'PLN', symbol: 'zł' },
    { code: 'RUB', symbol: '₽' },
    { code: 'SAR' }, // https://en.wikipedia.org/wiki/Saudi_riyal
    { code: 'SEK', symbol: 'kr' }, // https://en.wikipedia.org/wiki/Swedish_krona
    { code: 'THB', symbol: '฿' },
    { code: 'TRY', symbol: '₺' }, // https://en.wikipedia.org/wiki/Turkish_lira
    { code: 'TWD', symbol: 'NT$' },
    { code: 'ZAR', symbol: 'R' },
  ];
  private destroyed$$ = new Subject<void>();

  ngOnDestroy(): void {
    this.destroyed$$.next();
  }

  onBlur(isOpen: boolean): void {
    if (!isOpen) {
      this.currencyFormControl.updateValueAndValidity();
    }
  }
}

@NgModule({
  declarations: [CurrencyChoiceComponent],
  exports: [CurrencyChoiceComponent],
  imports: [CommonModule, MatSelectModule, ReactiveFormsModule, TranslateModule, GalaxyFormFieldModule],
})
export class CurrencyChoiceComponentModule {}
